module.exports = __webpack_public_path__ + "placa_smart_10x_s_1x9_carne.png?46b33148d310ba57e8463aaed1c68b9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_smart_10x_s_1x9_carne.png
// module id = 129
// module chunks = 0